
const { location, alert } = require('window');

const _ = require('lodash');
const $ = require('jquery');
require('rgs-bootstrap');
import ko from 'rgs-knockout';
const page = require('page-common');

const server = require('server');


function FormControllerBase (options) {
	options = _.defaults({}, options, {
	});

	this._options = options;

	this._model = new this._modelConstructor(options);

	this._model.on('submitButtonClick', this._onSubmitClick.bind(this));
}

_.extend(FormControllerBase.prototype, {
	_modelConstructor: null,
	_modalTemplate: null,
	_successModalTemplate: null,
	_title: null,

	open: function () {
		let $modal;
		if (this.$modal) {
			$modal = this.$modal;
		} else {
			$modal = this.$modal = $(this._modalTemplate);
			$modal.appendTo($('body')).wrap('<div class="bootstrap">');
		}
		if (!this._bindingsApplied) {
			ko.applyBindings(this._model, $modal[0]);
			this._bindingsApplied = true;
		}
		$modal.modal({
			show: true,
		});
	},

	_hideAndOpenSuccessModal: function () {
		// RGSSUP-25449: Хак для закрытия модального окна и его удаления из контейнера modals-container,
		// чтобы избежать его повторного отображения.
		$('.modals-container>.modal button[data-dismiss=\'modal\']')[0].click();
	
		page.notifications.push({
			template: {
				html: this._successModalTemplate,
			},
		});
	},

	_onSubmitClick: function () {
		const self = this;

		const invalid = !this._model.ValidationGroup().isValid();
		this._model.ValidationGroup().showAllMessages(invalid);
		if (invalid) {
			return;
		}

		let data = _.extend(
			{
				'web_form_submit': true,
				'referrerPage': location.pathname,
			},
			this._model.toJS(),
			_.pick(
				this._options,
				'WEB_FORM_ID',
				'SECTION_CODE_FOR_EMAIL',
				'bitrix_sessid'
			)
		);

		// HACK
		data['SiteSection'] = _.find({
			'/products/juristic_person/cargo/perevozchik/':
			'Страхование перевозчиков',
			'/products/juristic_person/cargo/expeditor/':
			'Страхование экспедиторов',
			'/products/juristic_person/railway/transport/':
			'Страхование средств железнодорожного транспорта',
			'/products/juristic_person/railway/container/':
			'Страхование контейнеров',
			'/products/juristic_person/liability/port/':
			'Страхование портовых операторов',
			'/products/juristic_person/cargo/':
			'Страхование таможенных операторов',
		}, (v, path) => (0 === location.pathname.indexOf(path)));

		data = _.mapKeys(data, function (value, key) {
			const bitrixKey = {
				'SiteSection': 'CALLBACK_SECTION',
				'LastName': 'CALLBACK_LAST_NAME',
				'FirstName': 'CALLBACK_FIRST_NAME',
				'MiddleName': 'CALLBACK_MIDDLE_NAME',
				'Phone': 'CALLBACK_PHONE',
				'Email': 'EMAILBACK_EMAIL',
				'CallTime': 'CALLBACK_CALL_TIME',
				'Comment': 'CALLBACK_COMMENT',
				'bitrix_sessid': 'sessid',
			}[key];
			if (!bitrixKey) {
				return key;
			}
			const bitrixQuestionId = _.get(
				self._options,
				'QUESTIONS[' + bitrixKey + '].STRUCTURE[0].ID'
			);
			return bitrixQuestionId
				? 'form_text_' + bitrixQuestionId
				: bitrixKey;
		});

		this._model.Working(true);

		server.any.cmsapi.form.submit({
			body: data,
		}).then(function () {
			self._hideAndOpenSuccessModal();
		}).fail(function (e) {
			alert('Произошла непредвиденная ошибка, пожалуйста, попробуйте позже.');
			throw e;
		}).finally(function () {
			self._model.Working(false);
		}).done();
	},
});

module.exports = FormControllerBase;

